import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrchestratorTriggerEtlDataInput, IOrchestratorTriggerEtlRes } from '../../../../../../interface/interfaces';

interface IInitialState {
    orchestrationTriggerEtlLoading: boolean;
    orchestrationTriggerEtlData: IOrchestratorTriggerEtlRes;
    orchestrationTriggerEtlError: string;
}

const orchestratorTriggerEtlBodyInitialValues: IOrchestratorTriggerEtlRes = {
    project_name: '',
    version: '',
    blob_urls: {
        excel_files: [],
        dxf_files: [],
        pdf_files: [],
    },
    errors: {
        string: '',
    },
};

const initialState: IInitialState = {
    orchestrationTriggerEtlLoading: false,
    orchestrationTriggerEtlData: orchestratorTriggerEtlBodyInitialValues,
    orchestrationTriggerEtlError: '',
};

const orchestrationTriggerEtlSlice = createSlice({
    name: 'orchestrationTriggerEtl',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchOrchestrationTriggerEtlPending: (state: IInitialState, action: PayloadAction<IOrchestratorTriggerEtlDataInput>) => {
            state.orchestrationTriggerEtlLoading = true;
            state.orchestrationTriggerEtlError = '';
        },

        fetchOrchestrationTriggerEtlFulfilled: (state: IInitialState, action: PayloadAction<IOrchestratorTriggerEtlRes>) => {
            state.orchestrationTriggerEtlLoading = false;
            state.orchestrationTriggerEtlData = action.payload;
            state.orchestrationTriggerEtlError = '';
        },

        fetchOrchestrationTriggerEtlFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.orchestrationTriggerEtlLoading = false;
            state.orchestrationTriggerEtlData = orchestratorTriggerEtlBodyInitialValues;
            state.orchestrationTriggerEtlError = action.payload;
        },
    },
});

export default orchestrationTriggerEtlSlice.reducer;
export const { fetchOrchestrationTriggerEtlPending, fetchOrchestrationTriggerEtlFailure, fetchOrchestrationTriggerEtlFulfilled } = orchestrationTriggerEtlSlice.actions;
